import { provide, inject, type InjectionKey } from 'vue'
import {
  createEmptyCareerYagiofferFormatData,
  type CareerYagiofferFormatData
} from '@/composables/format-edit/useCareerYagiofferHistories'

export type NewYagiofferFormatData = CareerYagiofferFormatData & {
  department?: string
  registYagioffer?: boolean
}

const NEW_YAGIOFFER_FORMAT_DATA_KEY: InjectionKey<NewYagiofferFormatData> =
  Symbol('newYagiofferFormatData')

export function createEmptyNewYagiofferFormatData(): NewYagiofferFormatData {
  return {
    ...createEmptyCareerYagiofferFormatData(),
    department: '',
    registYagioffer: false
  }
}

export function provideNewYagiofferFormatData(
  formatData: NewYagiofferFormatData
) {
  provide(NEW_YAGIOFFER_FORMAT_DATA_KEY, formatData)
}

export function useNewYagiofferFormatData(): NewYagiofferFormatData {
  const formatData = inject(NEW_YAGIOFFER_FORMAT_DATA_KEY)
  if (!formatData) {
    throw new Error(
      'useNewYagiofferFormatData() must be used under NewYagiofferEdit'
    )
  }
  return formatData
}
